<template>
  <div id="new-list-modal" v-if="isShown">
    <div class="custom-modal">
      <span class="icon-close" v-on:click="resetModal" />
      <div class="new-list-modal-content">
        <h2>{{ pageTitle }}</h2>
        <h4>{{ pageDescription }}</h4>

        <div class="input-title">
          <div class="title bold">{{listNameLabel}}</div>
          <input type="text" name="title" v-model="listTitle" />
        </div>

        <div class="input-description">
          <div class="description bold">{{listDescriptionLabel}}</div>
          <textarea
            v-model="listDescription"
            @input="mixin_autoResize_resize"
            @focus="mixin_autoResize_resize"
          />
        </div>

        <email-inputs-list v-bind:emails.sync="emails"></email-inputs-list>
      </div>

      <div class="btn-container">
        <primary-button
          class="primary-btn"
          v-bind:act="createNewList"
          title="Start session"
        ></primary-button>
      </div>
    </div>
    <div class="overlay" @click="resetModal"></div>
  </div>
</template>

<script>
import bus from "../bus";
import api from "../api";

import mixinAutoResize from "../mixins/autoResize.js";

import EmailInputsList from "../components/EmailInputsList";
import PrimaryButton from "./shared/PrimaryButton";

import createList from "../gql/lists/createList.gql";
import createInvited from "../gql/invited/createInvited.gql";

export default {
  data() {
    return {
      isShown: false,
      pageTitle: "Start a brainstorming session",
      pageDescription: "Create a session and then invite some people to share their ideas",
      listNameLabel: "What is the subject you want to brainstorm?",
      listDescriptionLabel: "Share more details about the subject or the goal of the brainstorming session.",
      listTitle: "",
      listDescription: "",
      emails: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    createNewList: function () {
      let owner_id = this.$store.state.user.id;
      let title = this.listTitle;
      let description = this.listDescription;

      if (this.listDescription == "") {
        description = null;
      }

      if (title.trim() === "") {
        alert("Please add a title to your list");
        return;
      }

      this.$apollo
        .mutate({
          mutation: createList,
          variables: {
            owner_id,
            title,
            description,
          },
        })
        .then((res) => {
          let listId = res.data.insert_lists_one.id;

          const list_id = res.data.insert_lists_one.id;
          const user_id = owner_id;

          api.addUserToList(list_id, user_id, "active");

          for (let i = 0; i < this.emails.length; i++) {
            const email = this.emails[i].email;
            const list_id = listId;
            this.$apollo
              .mutate({
                mutation: createInvited,
                variables: {
                  email,
                  list_id,
                },
              })
              .then(() => {
                api.createEventTracking(
                  "member-invited-new-list",
                  "member-invited",
                  this.user.id,
                  true
                );

                api.sendInvitationEmail(
                  email,
                  title,
                  this.user.name + " " + this.user.surname,
                  "https://www.otti.io/lists/" + list_id
                );
              });
          }
          api.createEventTracking(
            "list-created-modal",
            "list-created",
            user_id,
            true
          );

          this.resetModal();

          this.$router.push("/lists/"+listId);
        });
    },
    newListModalEvent: function () {
      bus.$on("new-list-mode", () => {
        this.isShown = true;
      });
    },
    clearData: function () {
      this.listTitle = "";
      this.emails = [];
    },
    resetModal: function () {
      this.isShown = false;
      this.clearData();
    },
  },
  components: {
    EmailInputsList,
    PrimaryButton,
  },
  beforeMount: function () {
    this.newListModalEvent();
  },
  mixins: [mixinAutoResize],
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

#new-list-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: theme.$white-background;
  padding: 0px theme.$page-padding-X;
  z-index: 20;
  overflow: scroll;
}

.new-list-modal-content {
  margin-top: 40px;
  overflow: visible;
}

span.icon-close {
  cursor: pointer;
  font-size: 24px;
  position: absolute;
  top: 30px;
  right: 30px;
}

.input-title {
  margin-top: 40px;
  margin-bottom: 20px;
}

.input-description {
  margin-bottom: 16px;
}

.input-title .title,
.input-description .description {
  margin-bottom: 8px;
}

input,
textarea {
  width: 100%;
  outline: none;
  background: theme.$white-background;
  border: 1px solid theme.$text-color;
  box-sizing: border-box;
  border-radius: theme.$button-border-radius;
  padding: 6px 8px;
  font-size: 14px;
  font-weight: 300;
}

textarea {
  max-height: 220px;
  resize: vertical;
  min-height: 3em;
}

.btn-container {
  position: -webkit-sticky;
  position: sticky;
  padding: 15px 30px;
  margin-left: - theme.$page-padding-X;
  margin-right: - theme.$page-padding-X;
  margin-top: 10px;
  background-color: theme.$white-background;
  bottom: 0;
}

h4 {
  font-size: 14px;
  font-weight: 400;
}

@media (min-width: 768px) {
  #new-list-modal {
    background-color: initial;
  }

  .custom-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    max-height: 600px;
    z-index: 20;
    background-color: theme.$white-background;
    padding: theme.$page-padding-top theme.$page-padding-X;
    overflow: scroll;
  }

  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: theme.$dark-grey-background;
    opacity: 0.6;
    padding: 0px theme.$page-padding-X;
    z-index: 15;
  }
}
</style>